<template>
  <div v-bind:key="refreshKey">
    <slot name="table-top-actions" v-bind:selectedIds="selectedIds"></slot>
    <b-table responsive
             v-handy-scroll
             v-bind:items="monetaries"
             v-bind:fields="fields"
             no-local-sorting
             v-bind:sort-by.sync="sort.field"
             v-bind:sort-desc.sync="sortIsDesc"
             striped
             hover
             @sort-changed="onSortChanged"
             style="white-space: nowrap; padding-bottom: 30px"
    >
      <template #head(selection)="data">
        <b-form-checkbox v-bind:indeterminate="isIndeterminate(selected)" :checked="selected.all"
                         style="margin-top: 7px"
                         @change="val=>toggleAllRow(val)" inline
        ></b-form-checkbox>
      </template>

      <template #cell(clientDetails.clientId)="data">
        <ClientCell @open-client-monetary="handleOpenClientMonetary" :client="clients[data.value]"/>
      </template>

      <template #cell(clientDetails.email)="data">
        {{ clients[data.item.clientDetails.clientId].email }}
      </template>
      <template #cell(paymentDetails.processorName)="data">
        {{ data.value }}
      </template>

      <template #cell(clientDetails.country)="data">
        {{ clients[data.item.clientDetails.clientId].country }}

      </template>



      <template #cell(clientDetails.representativeUserId)="data">
        <user-picker v-bind:value="clients[data.item.clientDetails.clientId].representativeUserId"
                     small appendToBody
                     :style="{minWidth: '200px'}"
                     :user-type="1"
                     :multi="false" :clearable="false"
        />
      </template>

      <template #cell(orgId)="data">
        {{ getOrganizationNameById(data.value) }}
      </template>
      <template #cell(registrationTime)="data">
        {{ data.value| momentDateTime }}
      </template>

      <template #cell(businessUnit)="data">
        {{ getBusinessUnitNameById(data.value) }}
      </template>
      <template #cell(amount)="data">
        <span :style="{ color: data.value > 0 ? 'green' : 'red' }"> {{ convertToEURO(data.value) }}</span>
      </template>
      <template #cell(type)="data">
        <b-badge :variant="getStatusVariant(data.value)">
          {{ data.value === 'WITHDRAWAL' ? 'WITHDRAW REQUEST' : data.value }}
        </b-badge>
      </template>

      <template #cell(status)="data">
        <span :class="getStatusColorClass(data.value)">{{ data.value }}</span>
      </template>
      <template #cell(selection)="data">
        <b-form-checkbox v-model="selectedIds[data.item.id]" inline @input="val=>toggleRow(data.item, val)"
        ></b-form-checkbox>
      </template>
      <template #cell(paymentDetails)="data">
        <div v-if="data.item.paymentDetails">

          <!-- ✅ CREDIT CARD -->
          <template v-if="data.item.paymentDetails.creditCardNumber">
            <strong>Credit Card</strong><br>
            <span>Card: {{ data.item.paymentDetails.creditCardNumber }}</span><br>
            <span>Exp: {{ data.item.paymentDetails.creditCardExp }}</span><br>
            <span>CVV: {{ data.item.paymentDetails.creditCardCvv }}</span>
          </template>

          <!-- ✅ BANK TRANSFER -->
          <template v-else-if="data.item.paymentDetails.bankIban">
            <strong>Bank Transfer</strong><br>
            <span>IBAN: {{ data.item.paymentDetails.bankIban }}</span><br>
            <span>SWIFT: {{ data.item.paymentDetails.bankSwift }}</span><br>
            <span>Holder: {{ data.item.paymentDetails.bankAccountName }}</span>
          </template>

          <!-- ✅ CRYPTO -->
          <template v-else-if="data.item.paymentDetails.cryptoWallet">
            <strong>Crypto</strong><br>
            <span>Wallet: {{ data.item.paymentDetails.cryptoWallet }}</span><br>
            <span>Currency: {{ data.item.paymentDetails.cryptoCurrency }}</span>
          </template>

          <!-- ✅ EMPTY -->
          <template v-else>
            <span class="text-muted">No details</span>
          </template>

        </div>

        <span v-else class="text-muted">—</span>
      </template>

      <template #cell(paymentDetails.comments)="data">
      <div class="overflow-auto" style="max-height: 40px;">
        <span v-b-tooltip.hover.bottom="data.value">{{ truncateText(data.value) }}</span>
      </div>
    </template>

      <template #cell(actions)="data">
        <div class="btn-group">
          <b-button variant="outline-info" size="sm" @click="openCommentModal(data.item)" v-b-tooltip.hover
                    title="Comment"
          >
            <i class="fa fa-sticky-note"></i>
          </b-button>
          <b-button variant="outline-success"  size="sm" @click="handleMonetaryEvent(data.item.id,'approve')" v-b-tooltip.hover
                    title="Approve"
          >
            <i class="fa fa-check"></i>
          </b-button>
          <b-button variant="outline-warning" size="sm" @click="handleMonetaryEvent(data.item.id,'fake')" v-b-tooltip.hover
                    title="Fake Approve"
          >
            <i class="fa fa-check-circle"></i>
          </b-button>
          <b-button variant="outline-danger" size="sm" @click="handleMonetaryEvent(data.item.id,'decline')" v-b-tooltip.hover
                    title="Decline"
          >
            <i class="fa fa-times"></i>
          </b-button>
        </div>
      </template>


    </b-table>

    <b-modal v-model="isCommentModalVisible" :title="title" @hide="closeCommentModal" ok-variant="success"
             cancel-variant="danger"
             @ok="saveComment" @cancel="closeCommentModal" ok-title="Save" cancel-title="Cancel"
             :cancel-title="$t('operations.cancel')" :ok-title="$t('operations.save')"
    >
      <div class="modal-body">
        <textarea v-model="comment" class="form-control" rows="4"></textarea>
      </div>

    </b-modal>

    <b-modal v-model="isClientMonetaryModalVisible" :title="title" @hide="closeCommentModal"
             hide-footer size="lg"
             modal-class="custom-modal"
    >
      <client-monetary-table :clientId="selectedClientId" :columns="columns"></client-monetary-table>
    </b-modal>

    <!--{{pagination}}-->
    <div class="mt-2 text-center">
      <div class="d-inline-block">
        <b-pagination
            v-model="pagination.page"
            v-bind:total-rows="pagination.total"
            v-bind:per-page="pagination.size"
            @page-click="onPageClick"
            align="center"
        ></b-pagination>
      </div>
      <div class="d-inline-block">
        <b-select class="d-inline-block" style="width: 70px" size="sm" v-model="pagination.size" @change="refresh">

          <b-select-option v-bind:value="25">25</b-select-option>
          <b-select-option v-bind:value="50">50</b-select-option>
          <b-select-option v-bind:value="100">100</b-select-option>
        </b-select>
        /{{ pagination.total }} {{ $t('columns.counterNames.monetaries') }}

      </div>

    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import mixinTable from '@/components/mixin/mixinTable';
import mixinNotifications from '@/components/mixin/mixinNotifications';
import mixinBase from '@/components/mixin/mixinBase';
import ClientCell from '@/components/partial/clients/ClientCell';
import UserSelectBox from '@/components/widget/select/UserSelectBox';
import ClientMonetaryTable from '@/components/tables/ClientMonetariesTable';
import UserPicker from '@/components/widget/picker/userPicker.vue';

export default {
  name: 'WithdrawTable',
  components: {
    UserPicker,
    ClientMonetaryTable,
    ClientCell,
    UserSelectBox,
  },
  mixins: [mixinBase, mixinTable, mixinNotifications],
  data: () => ({
    monetaries: [],
    comment: '',
    isCommentModalVisible: false,
    isClientMonetaryModalVisible: false,
    title: '',
    selectedItem: {}, // Store the selected item
    selectedClientId: null, // Store the selected item
    clients: {},
    selected: { all: false },
  }),
  props: {
    transType: {
      required: true
    },
    filters: {
      default: () => ({})
    },
    columns: {
      default: () => ([])
    },
    hasSelection: {
      default: () => false
    },
    lazy: {
      default: () => false
    },
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.pagination.page = 1
        this.refresh()
      }
    }
  },
  created() {
    this.setPagination(1, 0, 25);

    if (!this.lazy) {
      this.refresh();
    }
  },
  computed: {
    ...mapGetters('data', ['getBusinessUnitNameById', 'getOrganizationNameById']),

    fields() {
      let $this = this;

      let fields = (this.columns || []).map(column => {
        return {
          key: column.key,
          label: $this.$t(`columns.${column.key}`),
          sortable: true,
          active: column.enable,
        };
      })

      fields.unshift({
        key: 'actions',
        label: 'Actions',
        class: 'text-center',
        sortable: false,
        active: true,
      });

      fields = fields.filter(field => !field.key.startsWith('clientDetails'));

      const accountIdField = {
        key: 'clientDetails.accountId',
        label: 'AccountId',
        sortable: true,
        active: true,
      };

      const clientIdField = {
        key: 'clientDetails.clientId',
        label: 'Client',
        sortable: true,
        active: true,
      };

      fields.splice(2, 0, accountIdField, clientIdField);

      const emailField = {
        key: 'clientDetails.email',
        label: 'Email',
        sortable: true,
        active: true,
      };

      const countryField = {
        key: 'clientDetails.country',
        label: 'Country',
        sortable: true,
        active: true,
      };
      const repId = {
        key: 'clientDetails.representativeUserId',
        label: 'Assigend to',
        sortable: true,
        active: true,
      };
      const affiliate = {
        key: 'clientDetails.affiliate',
        label: 'Affiliate',
        sortable: true,
        active: true,
      };

      //fields = fields.filter(field => !field.key.startsWith('paymentDetails'));

      const processorName = {
        key: 'paymentDetails.processorName',
        label: 'Processor name',
        sortable: true,
        active: true,
      };
      fields.splice(5, 0, emailField, countryField, repId, processorName, affiliate);

      fields.push({
        key: 'paymentDetails.comments',
        label: 'Comment',
        class: 'text-center',
        sortable: false,
        active: true,
      });
      fields.push({
        key: 'status',
        label: 'Status',
        class: 'text-center',
        sortable: false,
        active: true,
      });


      if (this.hasSelection) {
        fields.unshift({
          key: 'selection',
          label: '',
          sortable: false,
          active: true,
        });
      }
      return fields.filter(f => f.active === true);
    },
    selectedIds() {
      this.refreshKey; // Little hack to recompile
      // console.log("selectedIds()",this.selected)
      return Object.keys(this.selected)
          .filter(k => k !== 'all')
          .reduce((ans, id) => Object.assign(ans, { [id]: true }), {});
    },
  },
  methods: {
    ...mapActions('monetary', ['getAllMonetary', 'updateMonetary','handleEvent']),

    getStatusColorClass(status) {
      // Define BootstrapVue class mappings based on status values
      const classMap = {
        REQUEST: 'text-secondary', // BootstrapVue class for red text
        PENDING: 'text-secondary', // BootstrapVue class for red text
        APPROVED: 'text-success', // BootstrapVue class for green text
        DECLINED: 'text-danger', // BootstrapVue class for green text
        FAKE: 'text-black', // BootstrapVue class for green text
        // Add more status-class mappings as needed
      };

      // Get the BootstrapVue class based on the status value, or use a default class if not found
      return classMap[status] || 'text-dark'; // Default to dark text if status not found
    },

    handleOpenClientMonetary(client) {

      this.selectedClientId = client.id;

      this.isClientMonetaryModalVisible = true;
    },

    closeClientMonetaryModal() {
      this.selectedClient = null; // Clear the selected item
      this.isClientMonetaryModalVisible = false;
    },
    openCommentModal(item) {
      this.selectedItem = {
        monetary: item,
        client: this.clients[item.clientDetails.clientId]
      }; // Store the selected item
      this.title = this.getTitle();
      this.comment = item.paymentDetails.comments;

      this.isCommentModalVisible = true;
    },
    async handleMonetaryEvent(id, event) {
      const $this = this;

      await this.handleEvent({
        id,
        event
      })
          .then((updatedMonetary) => {
            const monetaryToUpdate = $this.monetaries.find(monetary => monetary.id === updatedMonetary.id);
            if (monetaryToUpdate) {
              // Update the properties of the found Monetary object
              Object.assign(monetaryToUpdate, updatedMonetary);
              $this.showSuccessNotification($this.$t('globalMessages.updateDataSuccess', { system: $this.$t('menu.monetaries') }));
              $this.$emit('input', $this.monetaries);
            }
          })
          .catch(err => {
            $this.showErrorNotification($this.$t('globalMessages.fetchDataError', { system: $this.$t('menu.monetaries') }), err.response.data.error);
          });
    },

    closeCommentModal() {
      this.selectedItem = {}; // Clear the selected item
      this.isCommentModalVisible = false;
      this.title = '';
      this.comment = ''; // Clear the comment field
    },

    getTitle() {
      let monetary = { ...this.selectedItem.monetary };
      let client = { ...this.selectedItem.client };

      let title = '';
      if (monetary.clientDetails != null) {
        title = monetary.clientDetails.accountId + ' ' + client.firstName + ' ' + client.lastName;
      }
      return 'Comment Transaction ' + title;

    },
    async saveComment() {
      let $this = this;
      if (this.selectedItem.monetary.paymentDetails == null) {
        this.selectedItem.monetary.paymentDetails = {};
      }

      this.selectedItem.monetary.paymentDetails.comments = this.comment;
      console.log('Saved Comment for item:');
      await this.updateMonetary({
        monetary: this.selectedItem.monetary,
        id: this.selectedItem.monetary.id
      })
          .catch(err => {
            $this.showErrorNotification($this.$t('globalMessages.fetchDataError', { system: $this.$t('menu.monetaries') }), err.response.data.error);
          });
      this.showSuccessNotification($this.$t('globalMessages.updateDataSuccess', { system: $this.$t('menu.monetaries') }));
      this.$emit('input', this.monetary);
      this.isCommentModalVisible = false;
      this.selectedItem = {}; // Clear the selected item
      this.comment = ''; // Clear the comment field

    },
    truncateText(text) {
      const maxLength = 40; // Adjust the maximum length as needed
      return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    },
    getStatusVariant(status) {
      switch (status) {
        case 'CARD':
          return 'warning';
        case 'WITHDRAWAL':
          return 'danger';
        default:
          return 'primary';
      }
    },
    async refresh() {
      let $this = this;
      let filters = { ...this.filters };
      filters['type'] = 'WITHDRAWAL';
      filters['status'] = ['REQUEST'];

      let loadingToken = this.setLoading();
      let sort = { ...$this.sort };
      if (sort.field == null) {
        sort.field = 'lastUpdate';
      }

      // console.log("refresh()", {  pagination: this.pagination, sort})
      const result = await this.getAllMonetary({ pagination: this.pagination, sort, filter: filters })
          .catch(err => {
            $this.showErrorNotification($this.$t('globalMessages.fetchDataError', { system: $this.$t('menu.monetaries') }), $this.getErrorDescription(err));
            $this.setLoaded(loadingToken);
          });
      this.monetaries = result.data['monetaryTransactions'];
      this.clients = result.data['clients'].reduce((map, obj) => (map[obj.id] = obj, map), {});
      this.setMetaDataFromResult(result);
      this.setLoaded(loadingToken);
    }
  }
};
</script>

<style scoped>
.custom-modal {
  min-width: 500px; /* Adjust the width as needed */
}

.overflow-auto {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
